import { ExchangeRefundModalData } from '@entities/order';
import { createAction } from 'redux-actions';

export const SET_MODAL = 'REFUND/SET_MODAL';
export const CLOSE_MODAL = 'REFUND/CLOSE_MODAL';

export const setModal = createAction<ExchangeRefundModalData>(SET_MODAL);
export const closeModal = createAction(CLOSE_MODAL);

export type setModalAction = ReturnType<typeof setModal>;
export type closeModalAction = ReturnType<typeof closeModal>;

export type ActionModalTypes = setModalAction | closeModalAction;
